// core/components/ProtectedRoute.jsx
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { authActions } from '../core/action/authActions';
import all_routes from './all_routes';

const ProtectedRoute = ({ children, requiredPermissions = [] }) => {
    const [isAuthorized, setIsAuthorized] = useState(null);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        checkAuth();
    }, []);
    
    const checkAuth = async () => {
        setLoading(true);
        
        // Check if user is authenticated
        if (!authActions.isAuthenticated()) {
            setIsAuthorized(false);
            setLoading(false);
            return;
        }
        
        // Verify token with backend
        const result = await authActions.verifyToken();
        
        if (!result.success) {
            // Token is invalid or expired
            authActions.logout(); // Clear localStorage
            setIsAuthorized(false);
            setLoading(false);
            return;
        }
        
        // Check permissions if required
        if (requiredPermissions.length > 0) {
            const hasPermission = authActions.hasAnyPermission(requiredPermissions);
            setIsAuthorized(hasPermission);
        } else {
            // No specific permissions required, just authentication
            setIsAuthorized(true);
        }
        
        setLoading(false);
    };
    
    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                <div className="text-center">
                    <div className="spinner-border text-primary mb-3" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <h5 className="text-muted">Verifying Access...</h5>
                </div>
            </div>
        );
    }
    
    if (!isAuthorized) {
        // Redirect to login if not authorized
        return <Navigate to={all_routes.signin} replace />;
    }
    
    return children;
};

ProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired,
    requiredPermissions: PropTypes.arrayOf(PropTypes.string)
};

ProtectedRoute.defaultProps = {
    requiredPermissions: []
};

export default ProtectedRoute;